import React from 'react';
import { Button, Content, ContentVariants, PageSection, Title } from '@patternfly/react-core';
import { TimesIcon } from '@patternfly/react-icons';
import { ReportsMatrix } from '../components/ReportsMatrix';
import { usePageHeaderVisibility } from '../hooks';
import './Reports.css';

const Reports: React.FC = () => {
  const { isHeaderVisible, hideHeader } = usePageHeaderVisibility('reports');

  return (
    <PageSection hasBodyWrapper={false}>
      {isHeaderVisible && (
        <div className="reports-header">
          <div className="page-header__title-row">
            <Title headingLevel="h1" size="2xl">
              Reports
            </Title>
            <Button
              variant="plain"
              aria-label="Hide header"
              onClick={hideHeader}
              className="page-header__close-btn"
            >
              <TimesIcon />
            </Button>
          </div>
          <Content component={ContentVariants.p} className="reports-description">
            View aggregated time reports with configurable grouping and date range.
          </Content>
        </div>
      )}
      <ReportsMatrix />
    </PageSection>
  );
};

export { Reports };
